import * as React from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import { cn } from '@/lib/utils'

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipPortal = TooltipPrimitive.Portal

const TooltipProvider = React.forwardRef<
    React.ElementRef<typeof TooltipPrimitive.Provider>,
    React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Provider>
    >(({ children,delayDuration = 100, ...props }) => (
        <TooltipPrimitive.Provider
            children={children}
            delayDuration={delayDuration}
            {...props}
        />
))
TooltipProvider.displayName = TooltipPrimitive.Provider.displayName

const TooltipContent = React.forwardRef<
    React.ElementRef<typeof TooltipPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
    >(({ className, sideOffset = 4, arrowPadding= 5, ...props }, ref) => (
    <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
            ref={ref}
            sideOffset={sideOffset}
            className={cn(
                'z-50 text-sm border-0 rounded-sm bg-gray-highest text-white px-2 py-1 shadow-lg data-[state=instant-open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=instant-open]:fade-in-0  data-[state=closed]:zoom-out-95 data-[side=top]:animate-slideUp data-[side=bottom]:animate-slideDown',
                className,
            )}
            {...props}
        />
    </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

const TooltipArrow = React.forwardRef<
    React.ElementRef<typeof TooltipPrimitive.Arrow>,
    React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Arrow> & {
    inset?: boolean
}
    >(({ className, ...props }, ref) => (
    <TooltipPrimitive.Arrow
        ref={ref}
        className={cn(
            'fill-slate-700 -mt-[1px]',
            className,
        )}
        {...props}
    />
))
TooltipArrow.displayName = TooltipPrimitive.Arrow.displayName

export {
    Tooltip,
    TooltipTrigger,
    TooltipProvider,
    TooltipPortal,
    TooltipContent,
    TooltipArrow,
}
